/**
 * @Todo: consolidate this and shared.ts when we move all the components
 * into their own directory, and have a clearler understanding of levels
 */
import { NodeType } from "Types/Journey";

import type { FieldData } from "../shared";

export const getTitle = (type: string) => {
    switch (type) {
        case NodeType.Trigger:
            return "Trigger";
        case NodeType.Delay:
            return "Delay";
        case NodeType.Call:
            return "Create Call Task";
        case NodeType.SMS:
            return "Send SMS";
        case NodeType.AgentSMSTask:
            return "Create SMS Task";
        case NodeType.CancelTask:
            return "Cancel Task";
        case NodeType.Conditional:
            return "Conditional Match";
        case NodeType.CustomTask:
            return "Custom Task";
        case NodeType.ABTest:
            return "A/B Test";
        case NodeType.Webhook:
            return "Webhook";
        case NodeType.AssignTargetAgent:
            return "Assign Agent";
        case NodeType.UpdateTask:
            return "Update Task";
        case NodeType.UpdateContact:
            return "Update Contact";
        case NodeType.Reminder:
            return "Reminder";
        case NodeType.ScheduledCallback:
            return "Scheduled Callback";
        case NodeType.DEMO_EightByEight:
            return "Create 8x8 Call";
        case NodeType.DEMO_RinglessVM:
            return "Send Ringless VM";
        case NodeType.DEMO_AgentlessCall:
            return "Send Agentless Call";
        case NodeType.DEMO_VoiceAI:
            return "AI Voice Agent";
        case NodeType.DEMO_Genesys:
            return "Create Genesys Call";
        case NodeType.DEMO_Talkdesk:
            return "Create Talkdesk Call";
        case NodeType.DEMO_NICE:
            return "Create NICE Call";
        case NodeType.DEMO_Five9:
            return "Create Five9 Call";
        case NodeType.DEMO_SMSAI:
            return "AI SMS Agent";
        case NodeType.DEMO_CustomTaskAI:
            return "Custom AI Task";
        case NodeType.DecisionAI:
            return "AI Decision";
        case NodeType.DEMO_SendEmail:
            return "Send Email";
        case NodeType.DEMO_EmailTask:
            return "Create Email Task";
    }
    return "";
};

export const unflattenFields = (flattenedFields: Record<string, any>): Array<FieldData> => {
    return Object.entries(flattenedFields).map(([name, value]) => {
        return { name, value };
    });
};

export const removeAfterTouched = (fields: FieldData[]) => {
    const index = fields.indexOf(fields.find((x) => x.touched) as any);
    if (index > -1) {
        while (index < fields.length - 1) {
            fields.pop();
        }
        fields[index].touched = false;
    }
};
